import React from "react";
import PropTypes from "prop-types";
// import TextField from '@material-ui/core/TextField';
import TextField from '@mui/material/TextField';
import { makeStyles } from '@mui/styles';
import { styled } from '@mui/material/styles';
import thLocale from 'date-fns/locale/th'
import { InputBase, InputLabel, Paper } from '@mui/material';
import { green, red } from '@mui/material/colors';
import { ReDate } from './../../_source/Datefn'

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Padding, PaddingRounded } from "@mui/icons-material";

const BootstrapInput = styled(InputBase)(({ theme }) => ({
    'label + &': {
        marginTop: theme.spacing(3),
    },
    '& .MuiSvgIcon-root': {
        borderRadius: 4,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 13.5,
        padding: '5px 26px 5px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '"Customfont"',
        ].join(','),
        '&:focus': {
            borderRadius: 4,
            borderColor: "none",
            // boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    }
}));
const useStyles = makeStyles({
    inputgroupaddon: {
        // height: "22px",
        maxHeight: "22px",
        minWidth: "20px",
        width: "100px",
        padding: "2px",
        fontsize: "17px",
        fontWeight: "700",
        lineHeight: "1",
        color: "#555",
        textAlign: "center",
        backgroundColor: "#eee",
        border: "1px solid #ccc",
        borderRadius: "4px",
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        display: "table-cell",
        borderCollapse: "separate"
    },
    inputgroupaddon1: {
        // height: "22px",
        maxHeight: "22px",
        minWidth: '150px',
        width: "100px",
        padding: "2px",
        fontSize: "17px",
        fontWeight: "700",
        lineHeight: "1",
        textAlign: "right",
        borderRadius: "4px",
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        display: "table-cell",
        borderCollapse: "separate"
    },
    inputGroup: {
        position: "relative",
        display: "table",
        borderCollapse: "separate",
        float: "none",
        paddingRight: 0,
        paddingLeft: 0,
        marginTop: "2px",
        marginBottom: "3px",
        paddingLeft: "15px",
        paddingRight: "15px",
        width: "100%"
    },
    inputGroupPopup: {
        position: "relative",
        display: "table",
        borderCollapse: "separate",
        float: "left",
        paddingRight: '0px',
        paddingLeft: '0px',
        marginTop: "2px",
        marginBottom: "3px",
        width: '100%',
    },
    LocalizationProvider: {
        "& .MuiInputLabel-root": {
            padding: "1px",
            fontsize: "17px"
        },
        '& .MuiSvgIcon-root': {
            fontSize: "17px"
        },
        '& .MuiInputLabel-root': {
            border: "0",
            borderColor: red
        },

    },
    LocalizationProviderpopup: {
        "& .MuiInputLabel-root": {
            padding: "1px",
            fontsize: "17px"
        },
        '& .MuiSvgIcon-root': {
            fontSize: "15px"
        },
        '& .MuiInputLabel-root': {
            border: "0",
            borderColor: red,
        }
    },
    input: {
        "& .MuiOutlinedInput-input": {
            padding: "1px",
            fontSize: "17px",
            fontFamily: "Customfont",
            // height: "20px",

        },
        "& .Mui-focused": {
            color: '#00000'
        }
    },
    hiddenlabal1: { padding: "0px", width: "80%" }
});
const masklocale = '__/__/____'
const styles = {
    textField: {
        fontFamily: "Customfont !important"
    }
}


export default function CustomDatePicker(props) {

    const classes = useStyles();
    const { id, title, defaultdate, open, hiddenlabal, popup } = props
    const [value, setValue] = React.useState(new Date());
    const [datePickerdisabled, setdatePickerdisabled] = React.useState(false);
    React.useEffect(() => {
        setDefaultDate()
        // setdatePickerdisabled(open == 0 ? true : false)
    }, [defaultdate])


    React.useEffect(() => {
        setdatePickerdisabled(open === 0 ? true : false)
    }, [open])

    React.useEffect(() => {
        setDefaultDate()
    }, [])

    const setDefaultDate = () => {
        let newData
        if (defaultdate) {
            convertDate(defaultdate, "input")
            let strarr = defaultdate.split("/")
            newData = (Number(strarr[2]) - 543) + "-" + strarr[1] + "-" + strarr[0]
        } else if (defaultdate === null) {
            setValue(null);
        } else {
            newData = new Date()
        }
        convertDate(newData, "props")
    }
    const handleChange = (newValue) => {
        setValue(newValue);
        if (newValue === null) {
            props.DateValue(null)
        } else {
            convertDate(newValue, "props")
        }
    };
    const convertDate = async (dateValue, provenance) => {
        let newData

        //console.log("dateValue", dateValue.toISOString().split('T')[0])
        try {
            if (provenance === "props") {
                props.DateValue(dateValue.toISOString())
            } else if (provenance === "input") {
                let strarr = dateValue.split("/")
                newData = (Number(strarr[2]) - 543) + "-" + strarr[1] + "-" + strarr[0]
                setValue(dateValue !== "" ? Date.parse(newData) : new Date())
            }
        } catch (error) {
        }
    }
    return (
        <>
            <Paper
                elevation={0}
                component="div"
                sx={{
                    pl: '1px',
                    pt: '0px',
                    m: "0px",
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: "#eee",
                    border: "1px solid #ccc",
                    verticalAlign: "middle",
                }}
            >
                <InputLabel sx={{
                    width: "140px", whiteSpace: "nowrap",
                    fontSize: "17px",
                    fontFamily: "Customfont !important",
                    color: "black",
                    verticalAlign: "middle"
                }}  >{title}</InputLabel>

                <LocalizationProvider dateAdapter={AdapterDateFns} locale={thLocale} className={classes.LocalizationProvider} >
                    <DatePicker
                        disabled={datePickerdisabled}
                        mask={masklocale}
                        value={value}
                        renderInput={(params) =>
                            <TextField {...params} sx={{
                                "& label.Mui-focused": {
                                    display: "none",
                                },
                                "& legend": {
                                    display: "none",
                                },

                                backgroundColor: "#fff",
                                fontFamily: "Customfont",
                                "&  .MuiInputBase-input": {
                                    paddingTop: "2.5px",
                                    paddingBottom: "2.5px"
                                }

                                //     marginTop: "0px",
                            }}
                                fullWidth={true}
                                hiddenLabel
                                id={id}
                                variant="filled"
                                size="small"

                            />}
                        onChange={e => handleChange(e)}
                    />
                </LocalizationProvider>
            </Paper>
        </>
    );
}
CustomDatePicker.propTypes = {
    // You can declare that a prop is a specific JS primitive. By default, these
    // are all optional.  
    title: PropTypes.string,
    defaultdate: PropTypes.string,
    open: PropTypes.number,
    hiddenlabal: PropTypes.bool,
    popup: PropTypes.bool,
    id: PropTypes.string,
}
